import React, { createContext } from "react";

export const TempPageContext = createContext({ nodes: [] });

const TempPageProvider = ({ children, data }) => {
    return <TempPageContext.Provider value={data}>{children}</TempPageContext.Provider>;
};

export default TempPageProvider;
